import React from 'react';
export function ProofSection() {
  return <section className="bg-navy-800 py-20 px-4 sm:px-6 lg:px-8" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <div className="border-2 border-gold-500/30 rounded-2xl p-8 sm:p-12 bg-navy-900/50 text-center relative overflow-hidden" data-id="element-125">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-126"></div>
          <h2 className="font-playfair text-3xl font-bold text-white mb-6" data-id="element-127">
            Lo que cambia en <span className="text-gold-500" data-id="element-128">21 días</span>
          </h2>
          <p className="text-lg sm:text-xl text-[#e0e0e0] leading-relaxed" data-id="element-129">
            La mayoría de los hombres reportan una desaparición total de la
            neblina mental en la primera semana, seguida de un aumento notable
            en la energía matutina y una recuperación de la libido hacia el día
            14.{' '}
            <span className="font-semibold text-white" data-id="element-130">
              No es magia, es devolverle a tu cuerpo los micronutrientes que le
              has negado por años.
            </span>
          </p>
        </div>
      </div>
    </section>;
}